export const Blue = ({ children }) => (
  <span className="blue">{children}</span>
);

export const Red = ({ children }) => (
  <span className="red">{children}</span>
);

export const Rank = ({ children }) => (
  <span className="rank">{children}</span>
);

export const White = ({ children }) => (
  <span className="white">{children}</span>
);
